export default __webpack_public_path__ + "static/media/nuevo-origen.3e5e8264.svg";